import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-307"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.5 5.27a3.184 3.184 0 0 0-3.185-3.184 3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0A3.185 3.185 0 0 0 15.5 5.27zm-3.185 2.185a2.17 2.17 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.237 1.237 0 0 1 .17.018l.101.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.237 1.237 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369zM7.05 13.449a1 1 0 0 0 2 0 6.606 6.606 0 0 0-1-2 6.606 6.606 0 0 0-1 2zm-3.052-1.5a1 1 0 0 0 2 0 6.606 6.606 0 0 0-1-2 6.606 6.606 0 0 0-1 2zm6.028 0a1 1 0 0 0 2 0 6.606 6.606 0 0 0-1-2 6.606 6.606 0 0 0-1 2zm-8.976-.825a.786.786 0 0 0 1.572 0 5.192 5.192 0 0 0-.786-1.573 5.192 5.192 0 0 0-.786 1.573zm12.43 0a.786.786 0 0 0 1.572 0 5.192 5.192 0 0 0-.787-1.573 5.192 5.192 0 0 0-.786 1.573z",
  style: {"fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }